module.exports = __webpack_public_path__ + "img/3.e47aae46.png";